import { useParams } from "react-router-dom";
import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { MobileActivityTypeOverview, MobileActivityTypeNavigation } from "@/components/MobileNavigationLandingPage";
import { getActivityTypeNavLinks } from "./_utils";

export default function MobileActivityTypeLandingPage() {
  const { activityTypeId } = useParams();

  if (!activityTypeId) {
    return null;
  }

  const navLinks = getActivityTypeNavLinks(activityTypeId);

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      <Breadcrumb compactOnly compactTitle="Activity Type" backLink={{ to: "/activities/activity-types" }} />
      <MobileActivityTypeOverview activityTypeId={activityTypeId} />
      <MobileActivityTypeNavigation activityTypeId={activityTypeId} />
    </AppLayout>
  );
}
